import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'

// Rendered on the server so the HTML is never empty; the browser swaps in the live year after mount.
const FALLBACK_YEAR = 2026

export const CurrentYear: FC = (): ReactNode => {
    const [year, setYear] = useState<number>(FALLBACK_YEAR)

    useEffect(() => {
        setYear(new Date().getFullYear())
    }, [])

    return <>{year}</>
}
